const NAMESPACE = 'DUCKS/PRICING';

export default NAMESPACE;
